<template>
  <section class="hero">
    <div class="container">
      <div class="row">
        <div class="content col" :class="[cols.left || 'col-5']">
          <div class="title">
            <slot name="title" />
          </div>
          <HeroBenefits class="desktop-only" :benefits="benefits" />
          <slot name="countdown" />
          <div v-if="['both', 'title'].includes(footerTP)" class="footer-text desktop-only" :class="{ 'desktop-only': footerTP === 'both' }">
            <slot name="footer-text" />
          </div>
        </div>
        <div class="holder col" :class="[cols.right || 'col-6 offset-1']">
          <slot name="content" />
          <HeroBenefits class="mobile-only" :benefits="benefits" />
          <slot name="countdown-mobile" />
          <div v-if="['both', 'card'].includes(footerTP)" class="footer-text" :class="{ 'mobile-only': footerTP === 'both' }">
            <slot name="footer-text" />
          </div>
        </div>
      </div>
    </div>
    <template v-if="assets.backgroundsAsImages">
      <img
        v-show="$store.state.layout === 'desktop'"
        :src="require(`../../assets/images/campaigns/${assets.background}`)"
        class="hero-background desktop-only"
      >
      <img
        :src="require(`../../assets/images/campaigns/${assets.backgroundMobile}`)"
        class="hero-background mobile-only"
      >
    </template>
  </section>
</template>

<script>
import HeroBenefits from './HeroBenefits';

export default {
  components: {
    HeroBenefits,
  },
  props: {
    assets: { type: Object, default: () => ({}), required: true },
    benefits: { type: Array, default: () => ([]), required: false },
    cols: { type: Object, default: () => ({ left: 'col-5', right: 'col-6 offset-1' }) },
    footerTextPosition: { type: String, default: 'both', required: false },
  },
  computed: {
    footerTP() {
      const allowedFooterTextPositions = ['both', 'title', 'card'];

      if (allowedFooterTextPositions.includes(this.footerTextPosition)) {
        return this.footerTextPosition;
      }

      return 'both';
    },
  },
};
</script>

<style lang="scss" scoped>
.hero {
  padding-top: var(--spacing-140);
  position: relative;
  min-height: 700px;

  .hero-background {
    height: 800px;
    position: absolute;
    top: 0;
    left: 50%;
    object-fit: contain;
    object-position: center;
    transform: translateX(-50%);
    z-index: -2;
  }

  .row {
    margin: 0;
  }

  .content {
    color: var(--main-light);
    z-index: 1;

    .title {
      .main {
        font-size: 38px;
        font-weight: 500;
        line-height: 1.2;
        margin-bottom: 0;

        .highlight {
          font-weight: 800;
        }

        .highlight-special {
          display: block;
          font-size: 86px;
        }
      }

      .text-1 {
        margin: 0;
        font-size: 28px;

        .highlight {
          font-size: 32px;
        }
      }
    }
  }

  .holder {
    padding: 0 0 0 var(--spacing-30);

    .card {
      margin-left: auto;
      padding: var(--spacing-36);
      background-color: var(--main-light);
      border-radius: 0;
      box-shadow: -4px 4px 0 0 var(--c-mw-3);
      position: relative;
      max-width: 422px;

      &:before {
        content: '';
        position: absolute;
        top: 4px;
        right: -4px;
        bottom: -8px;
        left: 10px;
        background: var(--c-mw-1);
        z-index: -1;
      }

      .label {
        color: var(--main-dark-light-4);
        font-size: 20px;
        font-weight: 600;
        margin: 0;
      }

      .old-price {
        font-size: 30px;
        line-height: 110%;
        font-weight: 500;
        margin-top: var(--spacing-12);
        margin-bottom: 0;
        position: relative;
        display: inline-block;

        .del:after {
          content: '';
          width: 106px;
          height: 2px;
          background: var(--main-dark-light-1);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .new-price {
        font-size: 72px;
        font-weight: 500;
        line-height: 1.1;
        margin-top: var(--spacing-4);
        margin-bottom: var(--spacing-4);
        display: flex;
        align-items: flex-end;
        justify-content: flex-start;

        .medium {
          font-size: 30px;
          line-height: 50px;
        }

        .small {
          font-size: 21px;
          font-weight: 400;
          line-height: 50px;
        }
      }

      .text {
        margin: 12px 0;
        font-size: 21px;
        line-height: 1.4;
      }

      .card-text {
        font-size: 14px;
        line-height: 150%;
        color: var(--main-dark-light-2);
        text-align: center;
        margin: 0;
      }

      .stamp {
        position: absolute;
        top: 10px;
        right: -13px;

        img {
          display: block;
          width: 200px;
        }
      }
    }

    .footer-text {
      display: none;
    }
  }

  .countdown-label {
    font-weight: 700;
    font-size: 18px;
    line-height: 150%;
    margin-bottom: 5px;
  }

  @include bp($bp-laptop) {
    padding-top: 128px;

    .row {
      .holder {
        .card {
          padding: var(--spacing-36);
          max-width: 365px;

          .new-price {
            margin-top: var(--spacing-8);
            margin-bottom: var(--spacing-12);
            font-size: 60px;
          }

          .text {
            margin-bottom: var(--spacing-20);
          }

          .card-text {
            font-size: 12px;
          }
        }
      }

      .content {
        .footer-text {
          width: auto;
        }
      }
    }
  }

  @include bp($bp-mobile) {
    padding-top: 108px;

    &:after {
      content: '';
      display: block;
      position: absolute;
      z-index: -1;
      left: 0;
      width: 100%;
      bottom: 0;
      height: 180px;
      background: linear-gradient(0deg, #000C1F 0%, rgba(0, 12, 31, 0.77) 42.76%, rgba(0, 12, 31, 0) 108.02%);
    }

    .hero-background {
      object-fit: cover;
      max-width: 375px;
      width: 100%;
      height: 1450px;
    }

    .content {
      padding: 0;
      text-align: center;

      .title {
        margin-bottom: var(--spacing-40);
        text-align: center;

        .main {
          font-size: 32px;

          .block {
            display: block;
          }

          .highlight {
            font-size: 40px;
          }

          .highlight-special {
            font-size: 88px;
          }
        }
      }

      .text-1 {
        font-size: 24px;

        .highlight {
          font-size: 28px;
        }
      }

      .hero-benefits {
        display: none;
      }

      .footer-text {
        justify-content: center;

        .highlight {
          font-size: 20px;
        }
      }

      .countdown-label {
        margin-top: 24px;
        text-align: center;
      }
    }

    .holder {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      padding-left: 0;
      margin-top: 40px;

      .left-content {
        display: flex;
        flex-direction: column;
        align-content: space-between;
        order: 1;
        max-width: 525px;
        margin-right: var(--spacing-20);

        .countdown-label {
          color: var(--main-light);
        }

        .footer-text {
          display: block;
          line-height: 150%;
          text-align: left;

          .bold {
            font-weight: 600;
          }
        }
      }

      .card {
        padding: var(--spacing-24);
        margin: 0;
        width: 100%;

        .old-price {
          margin-top: var(--spacing-24);
        }

        .new-price {
          font-size: 58px;
          white-space: nowrap;
        }

        .text {
          font-size: 18px;
        }

        ::v-deep .counter {
          .square {
            width: calc((100% - 72px) / 4);
            height: 76px;
            padding: var(--spacing-12);
            margin: 0;

            .number {
              font-size: 32px;
              font-weight: 500;
            }

            .display-text {
              font-size: 12px;
            }

            + .square {
              margin-left: 8px;
            }
          }
        }

        .card-text {
          font-size: 12px;
          line-height: 130%;
        }

        .stamp {
          top: 24px;
          right: 24px;
          width: 80px;
          height: 80px;
          font-size: 22px;
        }
      }

      .hero-benefits {
        margin-top: 40px;
        margin-bottom: 0;
      }
    }

    &.mobile-reset {
      .hero-benefits {
        padding: 0 24px;
      }
    }
  }

  @media screen and (max-width: 920px) {
    .holder {
      padding: 0;
      flex-direction: column;

      .card {
        max-width: 428px;
        margin-bottom: var(--spacing-40);
      }

      .left-content {
        margin: 0;
        width: 100%;
        max-width: 100%;

        .footer-text {
          text-align: center;
        }
      }
    }

    .footer {
      .trusted-companies {
        margin-bottom: 0;
      }
    }
  }

  @include bp($bp-phone) {
    .holder {
      .card {
        max-width: 100%;

        .old-price {
          font-size: 24px;
          line-height: 24px;

          .del:after {
            width: 68px;
          }
        }

        .new-price {
          line-height: 58px;
        }

        .text {
          margin-bottom: var(--spacing-20);
        }

        .save-btn {
          padding: 0;
          font-size: 18px;
          line-height: 100%;
        }

        .card-text {
          color: #545C69;
        }
      }
    }

    .footer .trusted-companies .logos {
      column-gap: 22px;
    }
  }
}
</style>
